module.exports = __webpack_public_path__ + "img/switch-to-full-screen-button.176fdf1a.svg";